import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { Question } from "../calculator";

export const questionFormSchema = (variant: "add" | "edit", question?: Question): RJSFSchema => {
  const questionFormSchema: RJSFSchema = {
    title: question ? `questionId: ${question.questionId}` : "New Question",
    type: "object",

    properties: {
      question: { type: "string", title: "Question" },
      additionalInfo: { type: ["string", 'null'], title: "Additional Info" },
      answerType: {
        type: "string",
        title: "Answer Type",
        oneOf: [
          { const: "number", title: "Number" },
          { const: "select", title: "Select" },
          { const: "yes/no", title: "Yes/No" },
        ]
      },
      answers: {
        type: "array",
        title: "Answers",
        items: {
          type: "object",
          properties: {
            value: { type: "string", title: "Value" },
            patientDisplay: { type: "string", title: "Patient Display" },
            clinicianDisplay: { type: "string", title: "Clinician Display" },
          },
          required: ["value", "patientDisplay", "clinicianDisplay"],
        }
      }
    },
    required: ["question", "answerType"],
  }

  if (variant === "add") {
    questionFormSchema['properties']!['questionId'] = { type: "string", title: "Question ID" }
    questionFormSchema['required']!.push("questionId")
  }

  return questionFormSchema;

}

export const questionUiSchema = (variant: "add" | "edit"): UiSchema => {
  return {
    question: {
      "ui:widget": "textarea",
    },
    answers: {
      "ui:description": "Add as many answers as you need. Field should be empty for a Number or Yes/No.",
      items: {
        value: {
          "ui:description": "Enter value for the answer.",
        },
        patientDisplay: {
          "ui:widget": "textarea",
          "ui:description": "Enter text to display to the patient.",
        },
        clinicianDisplay: {
          "ui:widget": "textarea",
          "ui:description": "Enter text to display to the clinician.",
        }
      },
    },
    "ui:submitButtonOptions": {
      submitText: variant === "add" ? "Add" : "Update",
    }
  }
}